/**
 * Langfuse project IDs, per the stunnr-ai-api backend contract
 * (see app/schemas/common_schema.py `projectId`).
 */
export const LANGFUSE_PROJECT_IDS = {
  TEST_PROJECT: 1,
  STUNNR: 2
} as const;
